/**
 * streamlines add a dynamic value to width.
 * @param {object} param0
 * @param {number|string} param0.$width
 * @returns {string}
 */
const dynWidth = ({ $width }) => {
  if ($width === undefined) return "";
  if (typeof $width === "number") return `width: ${$width}px;`;
  return `width: ${$width};`;
};

export default dynWidth;
